<style scoped lang="less">
@import "../../assets/less/base.less";
.control-select-box{
    >.select-box{
        >.select-list{
            padding: 5px 7px;
            min-width: 90px;
            border: 1px solid @default-gray;
            margin-right: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height:32px;
            >span{
                margin-right: 10px;
                vertical-align: middle;
            }
            >img{
                cursor: pointer;
                vertical-align: middle;
            }
        }
        >.delete-all-btn{
            cursor: pointer;
            color: @default-black;
            padding: 6px;
            display: inline-block;
            float: left;
        }
        >p:nth-child(1){
            padding: 6px;
        }
    }
}
</style>
<template>
    <div class="control-select-box">
        <div class="clear select-box">
            <p v-show="localSelectList.length > 0 " class="lt">已选条件：</p>
            <p v-for="(item, index) in localSelectList" :key="index" class="lt select-list">
                <span class="">{{item.name | sliceText(10)}}</span>
                <img class="" src="../../assets/images/control-list-close.png" @click="deleteSelectList(item)">
                <!-- <i class="rt" @click="deleteSelectList(item)">x</i> -->
            </p>
            <p v-show="localSelectList.length > 0 " @click="deleteSelectList('all')" class="delete-all-btn">清空</p>
        </div>
    </div>
</template>
<script>
//introduce: 对选中的列表进行操作（删除)
import eventBus from '../../eventBus/eventBus.js'

export default {
  components: {},
  props: {
      selectedList: {
        type: Array,
        default: function(){
            return [{
                        name: '展示',
                        id: '123',
                        pid: '101'
                    }]
        }
      }
  },
  data() {
    return {
        localSelectList: [],
    };
  },
  computed: {

  },
  watch: {
    selectedList(newVal, oldVal){
        this.localSelectList = newVal;
    }
  },
  methods: {
      //清空按钮
    deleteSelectList(obj){
        if(obj === 'all'){
            this.localSelectList = [];
            eventBus.$emit('delete', 'all')
        }else{
            let index = this.localSelectList.indexOf(obj);
            _.each(this.localSelectList, (val, index, arr)=>{
                if(val.id == obj.id && val.name == obj.name && val.pid == obj.pid){
                    this.localSelectList.splice(index, 1);
                    eventBus.$emit('delete', obj)
                }
            })
        }
    }
  },
  created() {

  },
  mounted() {

  }
};
</script>





// WEBPACK FOOTER //
// src/containers/ControlSelectList/ControlSelectList.vue